import { useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { driverModel } from '~/entities/common/Driver'
import { CreateRentalContract } from '~/features/common/RentalContracts/CreateRentalContract'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

export const CreateRentalContractPage = () => {
  const { t } = useTranslation()

  const params = useParams<{ driverId: string }>()
  const driverId = params.driverId as string

  const fullName = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getFullName(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      {
        titleI18n: 'drivers',
        link: '/drivers',
      },
      {
        title: fullName || '...',
        link: `/drivers/${driverId}/details`,
      },
      {
        titleI18n: 'contracts',
        link: `/drivers/${driverId}/rental-contracts`,
      },
      { titleI18n: 'contract creation' },
    ],
    [driverId, fullName],
  )

  return (
    <PageContainer title={t('contract creation')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('contract creation')}</PageTitle>
      </Container>

      <CreateRentalContract />
    </PageContainer>
  )
}
